import ListPage, { TListPage } from 'components/ListPage';
import * as baseConfig from 'schemas/eventResources';

const ResourcesTab = (props: Partial<TListPage>) => {
  return <ListPage {...props} entityName="invitedResource" {...baseConfig} allowRowClick={false} />;
};

export default ResourcesTab;
